/*
 * @Author: your name
 * @Date: 2020-11-17 16:08:14
 * @LastEditTime: 2020-12-02 14:53:59
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\store\modules\product.js
 */
// import {login, logout} from '../../api/login'
import Cookies from "js-cookie";
import hui from "h_ui/dist/h_ui.min.js";

const product = {
  state: {
    request: [], //市场的请求条件
    searKeyWord: "", //搜索关键字
    newsActiveTab: "", //咨询活动按钮
    urlList: "" //地址映射
  },
  mutations: {
    SET_REQUEST: (state, data) => {
      state.request = data;
    },
    SET_SEARCH: (state, key) => {
      state.searKeyWord = key;
    },
    SET_NEWTAB: (state, key) => {
      state.newsActiveTab = key;
    },
    SET_URL: (state, key) => {
      state.urlList = key;
    }
  }
};
export default product;



// WEBPACK FOOTER //
// ./src/gtn/store/modules/product.js